import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainView
  },
  // 관리자
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 네이버 로그분석 - SPA 페이지 전환 시 PV 전송
router.afterEach(() => {
  if (window.wcs) {
    if (!window.wcs_add) window.wcs_add = {}
    window.wcs_add['wa'] = 'CHANGE_ME_NAVER_WCS'
    window.wcs.inflow()
    window.wcs_do()
  }
})

export default router
